import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import '@angular/localize/init';
import { map, catchError } from 'rxjs/operators';
import { of } from 'rxjs';

import { ContactUsModel } from '@app/models/contactus.model';
import { RegularExpressions } from '@app/services/regular-expressions';
import { RankipediaService } from '@app/services/rankipedia.service';
import { AlertService, MessageSeverity } from '@app/services/alert.service';
import { isNullOrUndefined } from 'util';


@Component({
  selector: 'app-contact-us-dialog',
  templateUrl: './contact-us-dialog.component.html',
  styleUrls: ['./contact-us-dialog.component.scss']
})
export class ContactUsDialogComponent implements OnInit {
  isLoading = false;
  contactUsModel: ContactUsModel = new ContactUsModel("", "", "", 0);
  form: FormGroup = new FormGroup({});
  @Input() additionalMessage: string = null;
  @Output() closeEvent: EventEmitter<any> = new EventEmitter();

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private _alertService: AlertService,
    private _rankiService: RankipediaService  ) {
  }

  ngOnInit(): void {
    this.initForm();
  }
  
  private initForm() {
    this.form = new FormGroup({
      name: new FormControl(this.contactUsModel ? this.contactUsModel.name : null, { validators: [Validators.required, Validators.maxLength(100), Validators.pattern(RegularExpressions.Name)], updateOn: 'blur' }),
      email: new FormControl(this.contactUsModel ? this.contactUsModel.email : null, { validators: [Validators.required, Validators.maxLength(60), Validators.pattern(RegularExpressions.Email)], updateOn: 'blur' }),
      message: new FormControl(this.contactUsModel ? this.contactUsModel.message : null, { validators: [Validators.required, Validators.maxLength(2000)], updateOn: 'blur' })
    }, {});
  }

  submitRequest() {
    this.isLoading = true;
    this.contactUsModel.name = this.form.value.name;
    this.contactUsModel.email = this.form.value.email;
    this.contactUsModel.message = this.form.value.message;
    if (!isNullOrUndefined(this.additionalMessage)){
      this.contactUsModel.message = `${this.contactUsModel.message} [system added: ${this.additionalMessage}]`;
    }
    this.contactUsModel.typeOfInquiry = 1;
    return this._rankiService.submitFeedback(this.contactUsModel).subscribe(res => {
      if (res != null) {
         this._alertService.showMessage("Message Sent", res.Data, MessageSeverity.success);
      }
      this.isLoading = false;
      this.close();
    }),
      catchError(err => {
        console.log(err);
        this.isLoading = false;
        this._alertService.showMessage("Verification Issue", `We're sorry there was an error sending your message. ${err}`, MessageSeverity.error);
        return of<any>([]);
      });
      
    return true;
  }
  
  nameInvalid() {
    return (this.form.controls.name.touched && !this.form.controls.name.valid)
  }

  emailInvalid() {
    return (this.form.controls.email.touched && !this.form.controls.email.valid)
  }

  messageInvalid() {
    return (this.form.controls.message.touched && !this.form.controls.message.valid)
  }

  formIsValid() {
    const isValid = this.form.valid;
    return isValid;
  }

  close() {
    setTimeout(() => {
      this.closeEvent.emit();
    }, 500);
  }
}
